import React from 'react';
import ActiveText from '../modals/ActiveText';
import { VoucherPreview } from './VoucherPreview';
import { TRANSLATIONS } from '../../../translations';
import { voucherPreviewModalWidth } from '../../../constants';

const ShowVoucherPreview = ({ idListing, clickable, seats, productId }) => {
  return (
    <ActiveText
      clickable={TRANSLATIONS.CHECK_PREVIEW}
      content={<VoucherPreview listingId={idListing} seats={seats} productId={productId} />}
      title={TRANSLATIONS.VOUCHER_EXAMPLE}
      modalCustomWidth={voucherPreviewModalWidth}
    />
  );
};

ShowVoucherPreview.propTypes = {};

ShowVoucherPreview.defaultProps = {};

export { ShowVoucherPreview };
